import { useEffect } from 'react';
import { useRouter } from 'next/compat/router';
import { useObserver } from 'mobx-react-lite';
import { useFlags } from 'launchdarkly-react-client-sdk';

import useDispensary from 'dispensary/hooks/use-dispensary';
import useStores from 'shared/hooks/use-stores';
import { patchSessionContextCookie } from 'src/utils/session-context-cookie';

export function useIsStoreRoute(): boolean {
  const router = useRouter();
  return !!router?.pathname.startsWith('/stores/');
}

export default function useSessionContextCookieController(): void {
  const isStoreRoute = useIsStoreRoute();
  const { dispensary, loading } = useDispensary();
  const { user } = useStores();
  const flags = useFlags();
  const isEntitled = !!flags['growth.ecomm.session-context-cookie.entitlement'];
  const isLoggedIn = useObserver(() => !!user?.isLoggedIn);
  const firstName = useObserver(() => user?.firstName);

  useEffect(() => {
    if (!isStoreRoute || loading || !dispensary || !isEntitled) {
      return;
    }

    patchSessionContextCookie({
      storeSlug: dispensary.cName,
      storeName: dispensary.name,
      firstName: isLoggedIn ? firstName : undefined,
    });
  }, [isStoreRoute, loading, dispensary, isEntitled, isLoggedIn, firstName]);
}
